<script>
import compoment from '@/components/draggable/VipDefaultComponents/DVipEditor'
export default {
  name: 'DGroupEditor',
  extends: compoment
}
</script>
